<div *ngIf="currentJob" class="bmc-jobs-steps">
    <table class="bz-table bz-space--stack-xl">
        <thead>
            <tr>
                <th *ngIf="jobType !== jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    {{'JOBS.COLUMN_ID' | translate}}
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    {{'JOBS.COLUMN_NAME' | translate}}
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    {{'JOBS.COLUMN_DESCRIPTION' | translate}}
                </th>
                <th *ngIf="jobType === jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    {{'JOBS.COLUMN_CODE' | translate}}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let step of currentJob.steps">
                <td *ngIf="jobType !== jobTypes.User" class="bz-table__cell">
                    {{step.idJob}}
                </td>
                <td class="bz-table__cell">
                    {{step.jsName || step.name}}
                </td>
                <td class="bz-table__cell">
                    {{step.jsDescription || step.description}}
                </td>
                <td *ngIf="jobType === jobTypes.User" class="bz-table__cell bmc-jobs-steps__table--cell-text">
                    {{step.jsCode || step.ruleDisplayName}}
                </td>
            </tr>
        </tbody>
    </table>
</div>
